module.exports = __webpack_public_path__ + "img/a10.665fa3c8.jpg";